import { render, staticRenderFns } from "./external-player.vue?vue&type=template&id=ebefeab2"
import script from "./external-player.vue?vue&type=script&lang=js"
export * from "./external-player.vue?vue&type=script&lang=js"
import style0 from "./external-player.vue?vue&type=style&index=0&id=ebefeab2&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports